'use client';

// Bloc widget "Contact" pour les pages CMS.
// Délègue à ContactForm qui supporte déjà le mode iframe (cf. settings.contact),
// mais ici on construit l'objet `contact` à partir du config du bloc.
import ContactForm from '@/components/ContactForm';

export default function ContactBlock({ config }) {
  if (!config) return null;
  const isIframe = (config.mode || 'form') === 'iframe';
  const contact = {
    enabled: true,
    title: config.title || '',  // champ vide => aucun titre (pas de defaut auto)
    subtitle: config.subtitle || '',
    // Styles texte propagés à ContactForm (qui les applique via applyTextStyle).
    title_style: config.title_style,
    subtitle_style: config.subtitle_style,
    email_destinataire: '',  // pas utilisé en mode iframe / réutilise default si form
    iframe_url: isIframe ? (config.iframe_url || '') : '',
    iframe_height_desktop: config.iframe_height_desktop || 700,
    iframe_height_mobile: config.iframe_height_mobile || 900,
    transparent_bg: !!config.transparent_bg,
  };
  return <ContactForm contact={contact} />;
}
